import React from "react";
import { Table, Card } from "react-bootstrap";
import {
	ResultWithRider,
	SnapshotWithEventandRider,
	TeamResultWithRider,
} from "../../../../types/model";
import getCountryISO2 from "country-iso-3-to-2";
import ReactCountryFlag from "react-country-flag";
import { getTotalPoints } from "../../../../utils/helper";

interface Props {
	results: ResultWithRider[];
	teamResults: TeamResultWithRider[];
	snapshot: SnapshotWithEventandRider;
	showSemisPoints?: boolean;
}

const PointsBreakdownBudgetMode: React.FC<Props> = ({
	results,
	teamResults,
	snapshot,
	showSemisPoints = false,
}) => {
	const teamResult = teamResults.find(
		(teamResult) =>
			teamResult.event === snapshot.event._id &&
			teamResult.brandTeamId == snapshot.selectedTeam,
	);

	return (
		<div className="bg-dark text-light">
			<Card
				className="my-0 bg-dark text-light border-0"
				style={{ fontSize: "0.9rem" }}
			>
				<Card.Header className="text-white py-1 bg-dark border-0 text-light">
					<div className="fw-bold mt-2">
						RIDER POINTS: {getTotalPoints(snapshot, results)}
					</div>
				</Card.Header>
				<Card.Body className="text-center py-2 bg-dark text-light">
					<Table
						striped
						bordered
						hover
						variant="dark"
						className="rounded bg-dark text-light"
						style={{ fontSize: "0.7rem", borderRadius: "10px" }}
					>
						<thead>
							<tr>
								<th className="text-start">Rider</th>
								<th>Qualifying Points</th>
								{showSemisPoints && <th>Semis Points</th>}
								<th>Finals Points</th>
								<th className="bg-dark text-light">Total</th>
							</tr>
						</thead>
						<tbody>
							{results?.length > 0 &&
								results
									.filter(
										(result) =>
											result.event === snapshot.event._id &&
											snapshot.riders.some(
												(rider) => rider.rider._id === result.rider._id,
											),
									)
									.map((filteredResult) => (
										<tr key={filteredResult._id}>
											<td className="text-start">
												{(filteredResult.finals_data?.rank ?? 0) > 0
													? filteredResult?.finals_data?.rank
													: ""}
												.
												{getCountryISO2(
													(filteredResult.rider.country ?? "")
														.toUpperCase()
														.trim(),
												) ? (
													<ReactCountryFlag
														countryCode={getCountryISO2(
															(filteredResult.rider.country ?? "")
																.toUpperCase()
																.trim(),
														)}
														svg
														style={{ width: "3.5rem" }}
													/>
												) : (
													filteredResult.rider.country
												)}
												<b>{filteredResult.rider.last_name}</b>{" "}
												{filteredResult.rider.first_name}
											</td>
											<td>{filteredResult?.qualifying_data?.points}</td>
											{showSemisPoints && (
												<td>{filteredResult?.semis_data?.points}</td>
											)}
											<td>{filteredResult?.finals_data?.points}</td>
											<td>{filteredResult.total_points}</td>
										</tr>
									))}
						</tbody>
					</Table>
				</Card.Body>
			</Card>
			<Card
				className="my-3 shadow bg-dark text-light border-0"
				style={{ fontSize: "0.9rem" }}
			>
				<Card.Header className="text-muted py-1 bg-dark border-0 text-light">
					<div className="d-flex flex-row justify-content-between">
						<div className="text-white fw-bold">
							TEAM POINTS ({teamResult?.name}): {teamResult?.points}
						</div>
						<div className="">
							{teamResults &&
								teamResults.length > 0 &&
								(teamResults.find(
									(teamResult) =>
										teamResult.event === snapshot.event._id &&
										teamResult.brandTeamId == snapshot.selectedTeam,
								)
									? teamResults.find(
											(teamResult) => teamResult.event === snapshot.event._id,
									  )?.points ?? 0
									: 0)}
						</div>
					</div>
				</Card.Header>
				<Card.Body className="text-center py-2 bg-dark text-light">
					<Table
						striped
						bordered
						hover
						variant="dark"
						className="bg-dark text-light"
						style={{ fontSize: "0.7rem" }}
					>
						<thead>
							<tr>
								<th className="text-start">Rider</th>
								<th>Points</th>
							</tr>
						</thead>
						<tbody>
							{teamResult?.riders?.map((rider) => (
								<tr key={rider.rider._id}>
									<td className="text-start">
										{getCountryISO2(
											(rider?.rider?.country ?? "").toUpperCase().trim(),
										) ? (
											<ReactCountryFlag
												countryCode={getCountryISO2(
													(rider.rider.country ?? "").toUpperCase().trim(),
												)}
												svg
												style={{ width: "3.5rem" }}
											/>
										) : (
											rider.rider.country
										)}
										<b>{rider.rider.last_name}</b> {rider.rider.first_name}
									</td>
									<td>{rider.points}</td>
								</tr>
							))}
						</tbody>
					</Table>
				</Card.Body>
			</Card>
		</div>
	);
};

export default PointsBreakdownBudgetMode;
